import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormAdapterContext = /*#__PURE__*/createContext(null);
export const useFormAdapter = () => {
  const ctx = useContext(FormAdapterContext);
  if (!ctx) {
    throw new Error('useFormAdapter must be used within <FormAdapterProvider>');
  }
  return ctx;
};
export const FormAdapterContextProvider = ({
  value,
  children
}) => /*#__PURE__*/_jsx(FormAdapterContext.Provider, {
  value: value,
  children: children
});
//# sourceMappingURL=FormAdapterContext.js.map